import { lazy } from "react";

export { DOCUMENT_REGISTER_TYPE_LIST_PATH } from "./document-register-type-list-path";
export const DocumentRegisterTypeListPage = lazy(
  () => import("./document-register-type-list-page"),
);
